import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';

import type { I18nTranslateOptions } from './i18n.service';
import { I18nService } from './i18n.service';

@Pipe({
  standalone: true,
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  private readonly i18nService = inject(I18nService);

  public transform(key: string, options: I18nTranslateOptions | any = {}): string {
    return this.i18nService.translate(key, options);
  }
}
